import React from "react";
import { Container, Box, Link } from "@cloudscape-design/components";
import Icon from "@cloudscape-design/components/icon";
import "./product-link-list.scss";

export interface ProductLinkItem {
  title: string;
  description: string;
  url: string;
  icon?: any;
}

export interface ProductLinkListProps {
  items: ProductLinkItem[];
  defaultIcon?: string;
}

const ProductLinkList: React.FC<ProductLinkListProps> = ({
  items,
  defaultIcon = "anchor-link",
}) => {
  return (
    <Container variant="stacked">
      <div className="product-link-list-grid">
        {items.map((item, index) => (
          <Link
            key={`${item.title}-${index}`}
            href={item.url}
            variant="info"
            fontSize="inherit"
            target="_blank"
          >
            <div className="product-item-container">
              <div className="product-item-icon">
                <Icon name={item.icon ?? defaultIcon} />
              </div>
              <div className="product-item-details">
                <Box fontWeight="heavy">{item.title}</Box>
                <Box className="product-item-description">{item.description}</Box>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </Container>
  );
};

export default ProductLinkList;
